import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ChevronDown from '../Icons/ChevronDown';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.div`
  cursor: pointer;
  font-family: var(--font-family-signika);
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  margin: 10px 0 ${({ isVisible }) => (isVisible ? '3px' : '15px')} 0;
  display: flex;
  align-self: flex-start;
  align-items: center;
  color: var(--river-bed);
`;

const Icon = styled(({ isVisible, ...rest }) => <ChevronDown {...rest} />)`
  cursor: pointer;
  color: #4a4a4a;
  margin-right: 10px;
  margin-left: 10px;
  width: 14px;
  top: 2px;
  transition: 0.2s transform;
  transform: rotate(${({ isVisible }) => (isVisible ? '180deg' : '0')});
`;

const ChildFadeIn = styled.div`
  animation: fadein 0.6s;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const ToggleRender = ({ children, label, defaultVisible }) => {
  const [isVisible, setisVisible] = useState(defaultVisible);
  return (
    <Container>
      <Label
        data-testid={`toggle-${label}`}
        isVisible={isVisible}
        onClick={() => setisVisible(v => !v)}
      >
        {label}
        <Icon isVisible={isVisible} />
      </Label>
      {isVisible && <ChildFadeIn isVisible={isVisible}>{children}</ChildFadeIn>}
    </Container>
  );
};

ToggleRender.defaultProps = {
  defaultVisible: false,
};

ToggleRender.propTypes = {
  defaultVisible: PropTypes.bool,
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
};
